import React from 'react';
import { getStatusLightAppearance } from '../utils/statusLightAppearance';
import StatusLightCircle from './StatusLightCircle';
import './StatusLightSymbol.css';

export default function StatusLightSymbol({ light, project }) {
    const appearance = getStatusLightAppearance(light, project);
    const label = `${light.colorName}燈：${light.label}`;
    if (appearance.type === 'circle') return <StatusLightCircle light={light} withText={appearance.withText} />;
    if (appearance.type === 'image') return <img src={appearance.src} width={appearance.size} height={appearance.size} alt={label} />;
    return <span className={`status-light-symbol status-light-symbol--${appearance.type}`} role="img" aria-label={label}
        style={appearance.type === 'block' ? { backgroundColor: appearance.background, color: appearance.foreground } : undefined}>
        {appearance.text}
    </span>;
}
